import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { getCountryStates } from '../../utils/country-states/country-states';
import type { Props as SelectProps } from '../Select/Select';
import Select from '../Select/Select';

import State from './components/State/State';

type Props = Partial<SelectProps>;

const StateSelect: React.FC<Props> = ({ children, country, title, name = 'state', ...props }) => {
  const locale = useSelector(select.locale.get);
  const siteId = useSelector(select.cms.getSiteId);

  return (
    <Select
      name={name}
      options={getCountryStates(country, { siteId, locale })}
      item={State}
      title={title}
      {...props}
    >
      {children}
    </Select>
  );
};

export default StateSelect;
